import { render } from "./userinfo.vue?vue&type=template&id=35b7a52c&scoped=true"
import script from "./userinfo.vue?vue&type=script&lang=js"
export * from "./userinfo.vue?vue&type=script&lang=js"

import "./userinfo.vue?vue&type=style&index=0&id=35b7a52c&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35b7a52c"]])

export default __exports__